import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Logo1 from '../../images/location_new/caseimg/logo1.webp';
import Img1 from '../../images/location_new/caseimg/img1.webp';
import Logo2 from '../../images/location_new/caseimg/logo2.webp';
import Img2 from '../../images/location_new/caseimg/img2.webp';
import Logo3 from '../../images/location_new/caseimg/logo3.webp';
import Img3 from '../../images/location_new/caseimg/img3.webp';
import Logo4 from '../../images/location_new/caseimg/logo4.webp';
import Img4 from '../../images/location_new/caseimg/img4.webp';
import {Case_Arrow} from '../../../app-constants';
import {Link} from 'gatsby';

const CaseStudy = [
    {
        logo: Logo1,
        title: 'The Idea Behind Nurse Practitioners',
        description: 'The Nurse Practitioners app is meticulously crafted with a singular purpose: to transform healthcare and showcase technologys positive influence on the end-users.',
        link: 'nurse-practitioners',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img1,
        BgColor: '#d5ccee',
        TextColor: '#6d4fc1'
    },
    {
        logo: Logo2,
        title: 'The Idea Behind MoCuts',
        description: 'MoCuts Pro serves as a digital marketplace connecting users with certified barbers, beauticians, and everyday grooming services, simplifying the booking process.',
        link: 'mocuts',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img2,
        BgColor: '#fff3f2',
        TextColor: '#78332a'
    },
    {
        logo: Logo3,
        title: "The Idea Behind Reck’N",
        description: 'An innovative solution that revolutionizes the restaurant experience, connecting customers and restaurants for seamless booking, enhanced social interaction, and efficient order processing.',
        link: 'reck-n-case',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img3,
        BgColor: '#bcbce0',
        TextColor: '#4041AB'
    },
    {
        logo: Logo4,
        title: 'The Idea Behind Equitrip',
        description:"Equitrip serves as a digital hub where horse owners, transport companies, and industry stakeholders unite to enhance horse transportation's convenience through collaboration.",
        link: 'hde',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img4,
        BgColor: '#fff7d6',
        TextColor: '#18274d'
    },
];

function Stories(props) {
    return (
        <div className="section_stories p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="Success">
                            <h2>Success Stories</h2>
                        </div>
                        <p>
                            Our steadfast dedication and intense focus on creating highly successful digital products have empowered businesses to revolutionize their respective sectors. We are excited to extend an invitation for you to discover a showcase of these remarkable accomplishments.
                        </p>
                    </Col>
                    {CaseStudy.map((item, index) => (
                        <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto" key={index}>
                            <div className="stories_item" style={{backgroundColor: item.BgColor}}>
                                <div className="item_logo">
                                    <LazyLoadImage
                                        src={item.logo}
                                        effect="blur"
                                        alt={item.title}
                                        className="img-fluid"
                                    />
                                    <ul style={{color: item.TextColor, borderColor: item.TextColor}}>
                                        <li>{item.technology.iOS}</li>
                                        <li>{item.technology.Android}</li>
                                    </ul>
                                </div>
                                <div className="item_tech">
                                    <div className="tech_content">
                                        <h4 style={{color: item.TextColor}}>{item.title}</h4>
                                        <p>{item.description}</p>

                                        <Link to={item.link ? `/case-studies/${item.link}` : 'https://www.tekrevol.com/projects'}
                                              className="case_btn"
                                              aria-label="TekRevol Contact" style={{backgroundColor: item.TextColor}}>
                                            View Case Study {Case_Arrow}
                                        </Link>
                                    </div>
                                    <div className="tech_img">
                                        <LazyLoadImage
                                            src={item.Img}
                                            effect="blur"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Stories;
